/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_User_DescriptionInputs */

const es_walkthrough_user_description = /** @type {(inputs: Walkthrough_User_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mirá tu perfil, administrá tus dispositivos y configurá tu clave API. También podés cambiar el idioma y cerrar sesión desde acá. Hacé clic en tu nombre para abrir tu perfil.`)
};

const en_walkthrough_user_description = /** @type {(inputs: Walkthrough_User_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View your profile, manage your devices, and configure your API key. You can also change the language and log out from here. Click on your name to open your profile.`)
};

/**
* | output |
* | --- |
* | "View your profile, manage your devices, and configure your API key. You can also change the language and log out from here. Click on your name to open your p..." |
*
* @param {Walkthrough_User_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_user_description = /** @type {((inputs?: Walkthrough_User_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_User_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_user_description(inputs)
	return en_walkthrough_user_description(inputs)
});
export { walkthrough_user_description as "walkthrough.user_description" }